import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import api from '../../../services/ApiManagement/Index';
import { useToast } from '../../../hooks/toast';
import { useOnlineStatus } from '../../../hooks/onlineStatus';

import { IconFlag, IconX } from '@tabler/icons';
import { Container, Wrapper } from './styles';

interface IAlertItem {
  type: 'green' | 'red';
  title: string;
  description: string;
  animalId: string;
  propertyId: string;
}

const Item: React.FC<IAlertItem> = ({
  type,
  title,
  description,
  animalId,
  propertyId,
}) => {
  const { addToast } = useToast();
  const isOnline = useOnlineStatus();
  const history = useHistory();

  const removeAlert = useCallback(async () => {
    try {
      await api.put(
        `/animais/${animalId}`,
        {
          alerta: {
            alerta_verde: {
              conteudo: '',
            },
            alerta_vermelho: {
              conteudo: '',
            },
          },
        },
        isOnline,
        {
          headers: {
            propriedade_id: propertyId,
          },
        },
      );

      history.go(0);

      addToast({
        type: 'success',
        title: 'Sucesso!',
        description: 'Alerta removido.',
      });
    } catch (err) {
      console.log(err);

      addToast({
        type: 'error',
        title: 'Erro!',
        description: err.response?.data?.message || 'Algo deu errado.',
      });
    }
  }, [animalId, propertyId, addToast, history, isOnline]);

  return (
    <Container>
      <Wrapper type={type}>
        <div>
          <IconFlag
            size={20}
            color={type === 'red' ? 'var(--danger)' : 'var(--success)'}
          />
        </div>

        <div>
          <strong>{title}</strong>
          <span>{description}</span>
        </div>
      </Wrapper>

      <button
        onClick={() =>
          window.confirm('Tem certeza de que deseja remover o alerta?')
            ? removeAlert()
            : null
        }
      >
        <IconX size={15} />
      </button>
    </Container>
  );
};

export default Item;
